// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3ege4","selects":"Documents_selects__4Fyck"};